import type { components } from '@/shared/api/schema'

export const returnBase = '/api/v1/procurement/supplier-returns'
export const returnReadPermissions = ['procurement.view_supplierreturn', 'procurement.view_purchasereceipt', 'inventory.view_inventorybatch']
export type ReturnDraft = components['schemas']['ReturnDraftInput']
export type ReturnDocument = components['schemas']['ReturnOutput']
export type ReturnCandidate = components['schemas']['ReturnCandidateOutput']
export type ReturnPreview = components['schemas']['ReturnPreviewOutput']
export type PendingReturn = { body: string; key: string; documentId?: number; action?: 'submit' | 'reject' | 'withdraw' | 'approve' }
export function parsePendingReturn(raw: string): PendingReturn {
  const value = JSON.parse(raw) as PendingReturn
  if (!value || typeof value.body !== 'string' || value.body.length > 300000
    || typeof value.key !== 'string' || !/^[0-9a-f-]{36}$/i.test(value.key)) throw new Error('Invalid recovery')
  if (value.action !== undefined) {
    const body = JSON.parse(value.body) as { expected_version: number; comment: string; approval_id?: number }
    if (!['submit', 'reject', 'withdraw', 'approve'].includes(value.action) || !Number.isSafeInteger(value.documentId)
      || Number(value.documentId) < 1 || !body || !Number.isSafeInteger(body.expected_version)
      || body.expected_version < 1 || typeof body.comment !== 'string' || body.comment.length > 2000
      || value.action !== 'submit' && (!Number.isSafeInteger(body.approval_id) || Number(body.approval_id) < 1))
      throw new Error('Invalid action recovery')
    return { body: value.body, key: value.key, documentId: value.documentId, action: value.action }
  }
  const body = JSON.parse(value.body) as ReturnDraft
  if (!body || !Number.isSafeInteger(body.supplier_id) || body.supplier_id < 1
    || typeof body.return_date !== 'string' || typeof body.reason !== 'string'
    || !['quality', 'damage', 'wrong_goods', 'commercial', 'other'].includes(body.return_reason)
    || !Array.isArray(body.lines) || !body.lines.length || body.lines.length > 200
    || body.lines.some(line => !line || ![line.source_receipt_line_id, line.batch_id, line.package_id].every(
      id => Number.isSafeInteger(id) && id > 0) || !Number.isInteger(line.package_count) || line.package_count < 0
      || typeof line.net_weight_kg !== 'string' || typeof line.return_unit_price !== 'string'
      || typeof line.measurement_reference !== 'string')) throw new Error('Invalid recovery body')
  if (value.documentId !== undefined && (!Number.isSafeInteger(value.documentId) || value.documentId < 1
    || !Number.isSafeInteger((body as ReturnDraft & { expected_version?: number }).expected_version)
    || Number((body as ReturnDraft & { expected_version?: number }).expected_version) < 1)) throw new Error('Invalid edit recovery')
  return { body: value.body, key: value.key, ...(value.documentId === undefined ? {} : { documentId: value.documentId }) }
}
